<template>
  <div>
    <b-row>
      <b-col md="7">
        <b-form-textarea
          id="textarea-default"
          placeholder="Concepto"
          rows="3"
          size="sm"
          v-model="concepto"
        />
      </b-col>
      <b-col md="3">
        <b-row>
          <b-col md="12">
            <b-form-spinbutton
              id="sb-maxmin"
              v-model="cantidad"
              placeholder="Cant"
              size="sm"
              min="0"
              @input="calculaSubtotal"
            />
          </b-col>
          <b-col md="12" class="mt-2 d-flex justify-content-center">
            <div
              variant="warning"
              style="color:#626262; font-size:15px"
            >
              Total: {{ valorTotal }} $
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="2">
        <b-row>
          <b-col md="12" class="p-0">
            <b-form-input
              placeholder="V.Unitario"
              size="sm"
              type="number"
              v-model="valorUnitario"
              @input="calculaSubtotal"
              class="m-0"
            />
          </b-col>
          <b-col md="12" class="mt-2 d-flex justify-content-center">
            <b-button
              v-if="!showLoading"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="primary"
              size="sm"
              @click="insertMultaIndividual"
            >
              <span class="align-middle">Guardar</span>
            </b-button>
            <div v-if="showLoading" class="text-center ">
              <b-spinner variant="primary" label="Text Centered" />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div
      v-if="messageError != ''"
      style="position:absolute; width:80%; text-align:center"
    >
      <span style="font-size:12px; color:red">{{ messageError }}</span>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  // BBadge,
  BButton,
  BFormTextarea,
  BFormSpinbutton,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import {
  URL,
  //   USER,
  //   ROLES,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    // BBadge,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSpinbutton,
    BSpinner,
  },
  props: {
    dataPartido: Object,
    idEquipo: String,
    campeonato: Object,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    const cantidad = ref(null)
    const valorUnitario = ref(null)
    const valorTotal = ref(0.0)
    const concepto = ref(null)
    const showLoading = ref(false)
    const messageError = ref(null)
    const { postApi } = apiCall()

    function calculaSubtotal() {
      if (cantidad.value !== null && valorUnitario.value !== null) {
        valorTotal.value = (cantidad.value * valorUnitario.value).toFixed(2)
      }
    }
    function hasErrorForm() {
      // console.log(concepto.value)
      let error = false
      if (
        concepto.value === undefined ||
        concepto.value === null ||
        concepto.value === ''
      ) {
        error = true
        messageError.value = 'Concepto no debe ser vacio'
      } else if (
        cantidad.value === undefined ||
        cantidad.value === null ||
        cantidad.value === 0
      ) {
        error = true
        messageError.value = 'La cantidad ingresada es incorrecta'
      } else if (
        valorUnitario.value === null ||
        valorUnitario.value === undefined ||
        Number(valorUnitario.value) <= 0 ||
        valorUnitario.value === ''
      ) {
        error = true
        messageError.value = 'valor unitario no válido'
      } else {
        error = false
        messageError.value = ''
      }
      return error
    }
    function resetValores() {
      messageError.value = ''
      concepto.value = null
      cantidad.value = null
      valorUnitario.value = null
      valorTotal.value = null
      showLoading.value = false
    }
    async function insertMultaIndividual() {
      valorTotal.value = cantidad.value * valorUnitario.value
      const data = {
        idEquipo: props.idEquipo || null,
        idPartido: props.dataPartido.id_partido,
        vUnitario: valorUnitario.value,
        vTotal: valorTotal.value,
        cantidad: cantidad.value,
        concepto: concepto.value,
        idCampeonato: props.campeonato.value,
        id_motivo_sancion: null,
      }
      const hasError = hasErrorForm()
      if (!hasError) {
        showLoading.value = true
        const path = 'ApiMultas/insertMultaIndividual'
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          const aux = {
            concepto: data.concepto,
            v_unitario: data.vUnitario,
            v_total: data.vTotal,
            cantidad: data.cantidad,
            id_multa: response.data.id_multa,
            bloquear: 'n',
            fecha: response.data.fecha,
            detalle: [],
            valor_cancelado: 0,
            valor_pendiente: data.vTotal,
            cancelado: false,
            tiene_detalles_bloqueados: false,
          }
          emit('multaInsertada', aux)
          resetValores()
        }
        // showLoading.value = false
      }
    }
    return {
      calculaSubtotal,
      insertMultaIndividual,
      concepto,
      cantidad,
      valorUnitario,
      showLoading,
      valorTotal,
      messageError,
    }
  },
}
</script>
